module.exports = __webpack_public_path__ + "static/media/appInfo4.fd1ab29b.png";